module.exports = __webpack_public_path__ + "static/media/login_background.3958b214.png";